import { useMemo } from 'react';
import { mainMenuItems } from './utils/utils';
import { appRoutes } from '../../../constants/appRoutes';
import { MainMenuItem } from './utils/types';
import { useSelector } from 'react-redux';
import { selectIsDisableAi } from '../../../reducers/userInfoReducer';

export const useMenuItemsWithPermissions = (): MainMenuItem[] => {
  const isDisableAi = useSelector(selectIsDisableAi);

  const menuItemsWithPermissions = useMemo(() => {
    return mainMenuItems.map((item) => {
      if (item.route === appRoutes.agenticLayer.route) {
        return {
          ...item,
          isHidden: isDisableAi,
        };
      }

      return item;
    });
  }, [isDisableAi]);

  return menuItemsWithPermissions;
};
